import { useContext } from 'react';

import { SearchContextProps } from '../contexts/search/types';
import { SearchContext } from './../contexts/search/context';

export function useSearch(): SearchContextProps {
    return useContext(SearchContext);
}
